module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com (7).bf7c8f99.svg";